import React from 'react';
import { ShoppingCartIcon, PackageIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-[#f8fafc] py-16 px-4" data-id="element-186">
      <div className="max-w-5xl mx-auto" data-id="element-187">
        <div className="text-center mb-12" data-id="element-188">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4" data-id="element-189">
            El Sistema de Fraccionamiento Inverso{' '}
            <span className="text-[#fbbf24]" data-id="element-190">(SFI)</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-191">
            Este protocolo te enseña a comprar con la fuerza de una familia
            numerosa pero a consumir con la precisión de un soltero. Usamos la
            ingeniería de "Marcas Blancas Espejo" y la logística de "Stockeo
            Cíclico" para que tú pongas el precio en la caja, no el
            supermercado.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-192">
          <div className="bg-white rounded-lg p-8 shadow-md border-2 border-[#fbbf24]" data-id="element-193">
            <div className="flex items-center gap-3 mb-4" data-id="element-194">
              <div className="p-3 bg-[#fbbf24] rounded-lg" data-id="element-195">
                <ShoppingCartIcon className="w-6 h-6 text-[#1a2332]" data-id="element-196" />
              </div>
              <h3 className="text-2xl font-bold text-[#1a2332]" data-id="element-197">
                Marcas Blancas Espejo
              </h3>
            </div>
            <p className="text-gray-700 leading-relaxed" data-id="element-198">
              Identifica productos de marca blanca con la misma calidad (o
              superior) que las marcas premium, pero a una fracción del precio.
              Aprende a leer etiquetas y comparar ingredientes como un experto.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-md border-2 border-[#fbbf24]" data-id="element-199">
            <div className="flex items-center gap-3 mb-4" data-id="element-200">
              <div className="p-3 bg-[#fbbf24] rounded-lg" data-id="element-201">
                <PackageIcon className="w-6 h-6 text-[#1a2332]" data-id="element-202" />
              </div>
              <h3 className="text-2xl font-bold text-[#1a2332]" data-id="element-203">
                Stockeo Cíclico
              </h3>
            </div>
            <p className="text-gray-700 leading-relaxed" data-id="element-204">
              Compra productos no perecederos en volumen una vez al mes en
              mayoristas, y frescos semanalmente. Maximiza tu poder de compra y
              elimina viajes innecesarios al supermercado.
            </p>
          </div>
        </div>
      </div>
    </section>;
}